import React, { useContext, useState, useEffect } from 'react'
import { Modal, Button } from 'antd'
import { AppContext } from 'AppContext'
import { isFinsaverProduct } from 'modules/Verification/productOptions'

const BrokerModal = ({ setVisible, refetch }) => {
  const {
    state: { currentUser },
  } = useContext(AppContext)
  const isFinsaver = isFinsaverProduct(currentUser)

  const [isModalVisible, setIsModalVisible] = useState(
    isFinsaver
      ? false
      : currentUser?.completedSteps === 'DONE'
      ? window.location.pathname.includes('/add-aua-verification')
        ? true
        : false
      : true
  )
  
  const [isIframeModalVisible, setIsIframeModalVisible] = useState(
    currentUser?.completedSteps === 'DONE'
      ? window.location.pathname.includes('/add-aua-verification')
        ? false
        : true
      : false
  )

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.action === 'closeIframe') {
        setIsModalVisible(false)
        setIsIframeModalVisible(false)
        if (
          currentUser?.completedSteps === 'DONE' &&
          !window.location.pathname.includes('/add-aua-verification')
        ) {
          setVisible(false)
          refetch()
        }
      }
    }
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setVisible])

  const handleOk = () => {
    setIsModalVisible(false)
    window.location.href = `${process.env.REACT_APP_BROKER_URL}/AdminSite/Pages/registrationForm.aspx?clientcode=${currentUser?.clientCode}&usercode=${currentUser?.userName}`
    // setIsIframeModalVisible(true)
  }
  const handleSkip = () => {
    setIsModalVisible(false)
    setIsIframeModalVisible(false)
    if (
      currentUser?.completedSteps === 'DONE' &&
      !window.location.pathname.includes('/add-aua-verification')
    ) {
      setVisible(false)
      refetch()
    }
  }

  return (
    <>
      <Modal
        title='Map your Broker'
        visible={isModalVisible}
        onOk={handleOk}
        centered
        maskClosable={false}
        closable={false}
      >
        <p style={{ fontSize: '14px' }}>
          <b>
            Dear {currentUser?.firstName + ' ' + currentUser?.lastName},<br />
            Please map your broker account to proceed with trade execution.
          </b>
        </p>
        <div
          style={{
            textAlign: 'right',
            display: 'flex',
            justifyContent: 'end',
            gap: '10px',
          }}
        >
          <Button type='primary' onClick={handleOk}>
            Proceed
          </Button>
          <Button type='primary' onClick={handleSkip}>
            Skip
          </Button>
        </div>
      </Modal>

      {isIframeModalVisible && (
        <Modal
          title='Broker Registration'
          visible={isIframeModalVisible}
          footer={null}
          centered
          width={1000}
          maskClosable={false}
          closable={false}
        >
          <iframe
            src={`${process.env.REACT_APP_BROKER_URL}/AdminSite/Pages/registrationForm.aspx?clientcode=${currentUser?.userCode}&usercode=${currentUser?.userName}`}
            width='100%'
            height='500px'
            style={{ border: 'none' }}
            title='brokerMapping'
          ></iframe>
        </Modal>
      )}
    </>
  )
}

export default BrokerModal
